import { render, staticRenderFns } from "./CelestialDisplay.vue?vue&type=template&id=e5fb7024&scoped=true&"
import script from "./CelestialDisplay.vue?vue&type=script&lang=js&"
export * from "./CelestialDisplay.vue?vue&type=script&lang=js&"
import style0 from "./CelestialDisplay.vue?vue&type=style&index=0&id=e5fb7024&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5fb7024",
  null
  
)

export default component.exports